/* eslint-disable default-param-last */
import { SET_USER_DATA, SET_ADMIN_DATA } from "../actions/userActions";

const initialUserState = {
  userData: null,
  adminData: null,
};

const userReducer = (state = initialUserState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.userData,
      };
    case SET_ADMIN_DATA:
      return {
        ...state,
        adminData: action.adminData,
      };
    default:
      return state;
  }
};

export default userReducer;
